import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06369114"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "textHidden" }
const _hoisted_4 = { class: "selected-value__multi-value" }
const _hoisted_5 = { class: "textHidden" }
const _hoisted_6 = {
  key: 1,
  class: "arrow"
}
const _hoisted_7 = {
  key: 1,
  class: "arrow-two"
}
const _hoisted_8 = {
  style: /*#__PURE__*/_normalizeStyle([{ height: '10px' }])
}
const _hoisted_9 = {
  style: /*#__PURE__*/_normalizeStyle([{ height: '10px' }])
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "third-color" }, "Список пуст", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["id", "checked"]
const _hoisted_16 = {
  key: 0,
  class: "select-error"
}

import { computed, onBeforeUnmount, onMounted, Ref, ref, toRaw, watch } from 'vue';
import { OptionsType, SelectInputTypesType, StylesType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectInput',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    height: { default: '36' },
    width: { default: '100%' },
    filled: { type: Boolean, default: false },
    styles: {},
    options: { default: () => [
      { id: 1, name: 'name 1' },
      { id: 2, name: 'name 2' },
    ] },
    type: { default: 'base' },
    showLabel: { type: Boolean, default: true },
    disabled: { type: Boolean },
    arrow: {},
    clearable: { type: Boolean },
    loading: { type: Boolean },
    textKey: { default: 'name' },
    valueKey: { default: 'id' },
    error: {},
    isMulti: { type: Boolean },
    searchCount: { default: 7 },
    showSearch: { type: Boolean, default: true },
    showCheckAll: { type: Boolean },
    withBg: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'update:modelValue',
  'blur',
  'focus',
  'deleteMultiSelectItem',
  'selectMultiItem',
], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// eslint-disable-next-line no-undef
const modelValue = _useModel<number | string | (number | string)[] | undefined>(__props, "modelValue");

const showMenu = ref(false);
const showInTop = ref(false);
const selectedItem: Ref<OptionsType | undefined> = ref(undefined);
const multiSelectedItem: Ref<OptionsType[]> = ref([]);

const selectInput = ref<HTMLElement | undefined>();
const selectLabel = ref<HTMLElement | undefined>();
const container = ref<HTMLDivElement | null>(null);
const selectDropdown = ref<HTMLDivElement | null>(null);
const tooltipActive = ref(false);
const openMenu = () => {
  if (selectInput.value) {
    const bottomDistance =
      window.innerHeight -
      selectInput.value.getBoundingClientRect().top -
      selectInput.value.getBoundingClientRect().height;

    showInTop.value = bottomDistance <= 200;
  }
  showMenu.value = !showMenu.value;
  calculateMenuPosition();
  emit('focus');
};

const isActiveMultiSelectedItem = (option: OptionsType | undefined): boolean => {
  return option ? multiSelectedItem.value.map(el => el.id).includes(option.id) : false;
};

const deleteMultiSelectItem = (option: OptionsType) => {
  multiSelectedItem.value = multiSelectedItem.value.filter(el => el.id !== option.id);
  if (multiSelectedItem.value.length) {
    modelValue.value = multiSelectedItem.value.map(el => el.id);
  } else {
    modelValue.value = undefined;
  }
  emit('deleteMultiSelectItem', option);
};

const checkAll = () => {
  props.options.forEach(option => {
    if (!isActiveMultiSelectedItem(option)) {
      multiSelectedItem.value.push(option);
      modelValue.value = multiSelectedItem.value.map(el => el.id);
      emit('selectMultiItem', option);
    }
  });
};
const selectMultiItem = (option: OptionsType | undefined) => {
  if (!props.isMulti) {
    return;
  }
  if (option) {
    if (isActiveMultiSelectedItem(option)) {
      deleteMultiSelectItem(option);
    } else {
      multiSelectedItem.value.push(option);
      modelValue.value = multiSelectedItem.value.map(el => el.id);

      emit('selectMultiItem', option);
    }
  } else {
    multiSelectedItem.value = [];

    modelValue.value = undefined;
  }
};
const selectItem = (option: OptionsType | undefined) => {
  if (props.isMulti) {
    return;
  }
  if (option) {
    selectedItem.value = {
      id: option[props.valueKey as keyof typeof option] as number,
      name: option[props.textKey as keyof typeof option] as string,
      icon: option.icon,
    };
    modelValue.value = selectedItem.value?.id;
  } else {
    selectedItem.value = undefined;

    modelValue.value = undefined;
  }
  showMenu.value = false;
};

const cssProps = computed(() => {
  return {
    '--border': props.styles?.border,
    '--background-color': props.styles?.backgroundColor,
    '--width-select-input': props.width === '100%' ? props.width : props.width + 'px',
  };
});
const classProps = computed((): string => {
  let classForInput: string;

  switch (props.type) {
    case 'mainColorBorder':
      classForInput = 'main-border-color';
      break;
    case 'light':
      classForInput = 'light';
      break;
    case 'text':
      classForInput = 'text';
      break;
    case 'green':
      classForInput = 'green';
      break;
    default:
      classForInput = 'base';
  }

  return classForInput;
});

const searchText = ref('');
const filteredOptions = computed(() => {
  const searchOptions = (val: string) => {
    return val.toLocaleLowerCase().includes(searchText.value.toLocaleLowerCase());
  };

  return props.options.filter(opt => {
    return searchOptions(opt[props.textKey as keyof OptionsType] as string);
  });
});

const topPosition = ref('0px');
const leftPosition = ref('0px');
const calculateMenuPosition = () => {
  if (container.value) {
    const rect = container.value.getBoundingClientRect();
    const scrollTop = window.scrollY ? window.scrollY : document.body.scrollTop;

    leftPosition.value = `${rect.x}px`;
    topPosition.value = `${rect.y + rect.height + scrollTop}px`;

    return;
  }

  topPosition.value = '100%';
  leftPosition.value = '0px';
};
const handleClickOutside = (event: MouseEvent) => {
  if (
    container.value &&
    !container.value.contains(event.target as Node) &&
    selectDropdown.value &&
    !selectDropdown.value.contains(event.target as Node)
  ) {
    showMenu.value = false;
    searchText.value = '';
  }
};

const updateSelectedItem = () => {
  if (props.isMulti) {
    if (modelValue.value) {
      (modelValue.value as number[]).forEach(value => {
        let foundValue = props.options.find(
          el => el[props.valueKey as keyof typeof el] === value,
        );

        if (
          foundValue &&
          !toRaw(multiSelectedItem.value).find(el => el.id === foundValue?.id)
        ) {
          multiSelectedItem.value.push(foundValue);
        }
      });
    } else {
      multiSelectedItem.value = [];
    }
  } else {
    selectedItem.value = props.options.find(
      el => el[props.valueKey as keyof typeof el] === modelValue.value,
    );
  }
  if (!props.loading) {
    calculateMenuPosition();
  }
};

onMounted(() => {
  if (selectLabel.value) {
    if (selectLabel.value.clientWidth < selectLabel.value.scrollWidth) {
      tooltipActive.value = true;
    }
  }

  document.addEventListener('click', handleClickOutside);
  updateSelectedItem();
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
watch(
  () => modelValue.value,
  () => {
    updateSelectedItem();
  },
);
watch(
  () => props.loading,
  () => {
    if (!props.loading) {
      calculateMenuPosition();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_tooltip = _resolveComponent("base-tooltip")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_skeleton_loader, { type: "input" })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        ref_key: "container",
        ref: container,
        class: _normalizeClass([{ active: showMenu.value }, "custom-select"]),
        style: _normalizeStyle(cssProps.value)
      }, [
        _createVNode(_component_base_tooltip, {
          active: tooltipActive.value,
          "show-in-mobile": false,
          text: _ctx.label
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              ref_key: "selectInput",
              ref: selectInput,
              class: _normalizeClass([[classProps.value, { invalid: _ctx.error?.length }], "custom-select__button"]),
              disabled: _ctx.disabled,
              style: _normalizeStyle([
          {
            height: _ctx.height + 'px',
          },
        ]),
              role: "combobox",
              type: "button",
              onClick: openMenu
            }, [
              _createElementVNode("span", {
                class: _normalizeClass([{ text: _ctx.type === 'text' }, "selected-container-value"])
              }, [
                (selectedItem.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([{ filled: _ctx.filled }, "selected-value"])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([{ 'selected-value__multi-value': _ctx.withBg }, "items-in-line gap--5"])
                      }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(selectedItem.value[_ctx.textKey]), 1),
                        (selectedItem.value.icon)
                          ? (_openBlock(), _createBlock(_component_base_icon, {
                              key: 0,
                              color: _ctx.type === 'green' ? '#ffffff' : '#009D3E',
                              name: selectedItem.value?.icon,
                              "font-size": "16"
                            }, null, 8, ["color", "name"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true),
                (multiSelectedItem.value && multiSelectedItem.value.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass([{ filled: _ctx.filled }, "selected-value"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multiSelectedItem.value, (item) => {
                        return (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item[_ctx.textKey]), 1),
                          _createVNode(_component_base_icon, {
                            clickable: "",
                            color: "#94857d",
                            "font-size": "20",
                            name: "close",
                            onClick: ($event: any) => (deleteMultiSelectItem(item))
                          }, null, 8, ["onClick"])
                        ]))
                      }), 256))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("span", {
                ref_key: "selectLabel",
                ref: selectLabel,
                class: _normalizeClass([{
            active: selectedItem.value || multiSelectedItem.value?.length,
            topMore: multiSelectedItem.value?.length || _ctx.withBg,
            filled: _ctx.filled,
            displayNone: !_ctx.showLabel,
          }, "selected-label"])
              }, _toDisplayString(_ctx.label), 3),
              (_ctx.clearable && selectedItem.value && !_ctx.isMulti)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    class: "clear-icon",
                    clickable: "",
                    color: "#94857d",
                    height: "18",
                    name: "close",
                    width: "18",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (selectItem(undefined)))
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    (_ctx.arrow)
                      ? (_openBlock(), _createBlock(_component_base_icon, {
                          key: 0,
                          color: _ctx.type === 'light' ? '#868298' : '#94857d',
                          name: _ctx.arrow,
                          height: "18",
                          width: "18"
                        }, null, 8, ["color", "name"]))
                      : (_ctx.type === 'text')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                              _createVNode(_component_base_icon, {
                                class: "step-up",
                                height: "10",
                                name: "arrow_drop_up",
                                tabindex: "-1",
                                width: "10"
                              })
                            ]),
                            _createElementVNode("span", _hoisted_9, [
                              _createVNode(_component_base_icon, {
                                class: "step-down",
                                height: "10",
                                name: "arrow_drop_down",
                                tabindex: "-1",
                                width: "10"
                              })
                            ])
                          ]))
                        : (_openBlock(), _createBlock(_component_base_icon, {
                            key: 2,
                            color: _ctx.type === 'green' ? '#ffffff' : undefined,
                            height: "18",
                            name: "arrow_drop_down",
                            width: "18"
                          }, null, 8, ["color"]))
                  ]))
            ], 14, _hoisted_2)
          ]),
          _: 1
        }, 8, ["active", "text"]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createElementVNode("div", {
            ref_key: "selectDropdown",
            ref: selectDropdown,
            class: _normalizeClass([{ active: showMenu.value }, "select-dropdown"]),
            style: _normalizeStyle({
          width: `${container.value?.getBoundingClientRect().width}px`,
          top: topPosition.value,
          left: leftPosition.value,
        })
          }, [
            (_ctx.options.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.options?.length > _ctx.searchCount && _ctx.showSearch)
                    ? (_openBlock(), _createBlock(_component_base_input, {
                        key: 0,
                        modelValue: searchText.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                        disabled: _ctx.disabled,
                        "append-icon": "search",
                        "auto-focus": "",
                        class: "select-dropdown__search",
                        "label-in-value": "",
                        placeholder: "Поиск"
                      }, null, 8, ["modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.showCheckAll)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "main-color mb--10",
                        onClick: checkAll
                      }, " Выбрать все "))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", {
                    id: "select-dropdown",
                    class: _normalizeClass({ showInTop: showInTop.value })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: option[_ctx.valueKey],
                        onClick: ($event: any) => (selectItem(option))
                      }, [
                        _createElementVNode("input", {
                          id: option[_ctx.valueKey],
                          checked: 
                  option[_ctx.valueKey] === selectedItem.value?.id ||
                  isActiveMultiSelectedItem(option)
                ,
                          type: "radio"
                        }, null, 8, _hoisted_15),
                        _createElementVNode("label", {
                          class: _normalizeClass({ isMulti: _ctx.isMulti })
                        }, [
                          _createElementVNode("span", null, _toDisplayString(option[_ctx.textKey]), 1),
                          (option.icon)
                            ? (_openBlock(), _createBlock(_component_base_icon, {
                                key: 0,
                                color: option[_ctx.valueKey] === selectedItem.value?.id ? '#009D3E' : 'black',
                                name: option.icon,
                                height: "18",
                                width: "18"
                              }, null, 8, ["color", "name"]))
                            : _createCommentVNode("", true),
                          (_ctx.isMulti)
                            ? (_openBlock(), _createBlock(_component_base_checkbox, {
                                key: 1,
                                "model-value": isActiveMultiSelectedItem(option),
                                "onUpdate:modelValue": ($event: any) => (selectMultiItem(option))
                              }, null, 8, ["model-value", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ], 8, _hoisted_14))
                    }), 128))
                  ], 2)
                ]))
          ], 6)
        ])),
        (_ctx.error?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ], 6))
}
}

})